import { connect } from 'react-redux';

import ColumnsArea from '../components/columns_area';

const mapStateToProps = state => {
  const pathname = window.location.pathname;
  const match = pathname.match(/@([^/]+)/);
  const username = match ? match[1] : null;

  const account = state.get('accounts').find(acc => acc.get('acct') === username);
  const userId = account?.get('id');

  return {
    suggestions: state.suggestions.items,
    isLoading: state.suggestions.isLoading,
    columns: state.getIn(['settings', 'columns']),
    isModalOpen: !!state.get('modal').modalType,
    me: state.getIn(['meta', 'me']),
    userId,
  };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(ColumnsArea);
